import { useState } from "react";
import EditIcon from "@/assets/common/ic_edit.svg?react";
import DeleteIcon from "@/assets/common/ic_delete.svg?react";
import Textarea from "@/component/Textarea";

interface HotWordGroupProps {
  onDelete: () => void;
}

const HotWordGroup: React.FC<HotWordGroupProps> = ({ onDelete }) => {
  const [isEdit, setIsEdit] = useState(false);
  const [title, setTitle] = useState("热词");
  const [content, setContent] = useState(
    "种草，拔草，案例，佛系，社畜，打工人，996，摸鱼，划水，柠檬精，996，显眼包，精神状态良好，遥遥领先，纯爱战士，内卷，躺平，配享太庙，惹到我算是踢到棉花啦，绝绝子，小丑竟是我自己，二次元控，家人们，破防了，我真的栓Q，回炉重造，手机依赖症"
  );

  const handleTitleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTitle(e.target.value);
  };

  const handleContentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setContent(e.target.value);
  };

  const handleSave = () => {
    setIsEdit(false);
  };

  return (
    <div className={`w-full bg-#fff min-h-24 rounded-2.5 px-6 py-3.5 flex mb-2 border-1 border-solid ${isEdit ? "border-color-#337AFF" : "border-color-transparent"}`}>
      <div className="flex-1">
        <div className="mb-3 text-4 lh-6 font-500 color-#191D26">
          {isEdit ? (
            <Textarea autoSize className="text-4 lh-6 font-500 border-0 outline-0 block w-full resize-none text-justify font-normal" value={title} onChange={handleTitleChange} />
          ) : (
            title
          )}
        </div>
        <div className="font-400 color-#191D26 text-3.5 lh-6">
          {isEdit ? (
            <Textarea
              autoSize
              className="text-3.5 lh-6 font-500 border-0 outline-0 block w-full resize-none text-justify font-normal"
              value={content}
              onChange={handleContentChange}
            />
          ) : (
            content
          )}
        </div>
      </div>
      <div className="flex ml-4.5">
        {isEdit ? (
          <div className="cursor-pointer bg-#337AFF min-w-18 h-7 lh-7 px-4.5 text-3 font-400 color-#fff text-center rounded-2.5" onClick={handleSave}>
            保存
          </div>
        ) : (
          <>
            <EditIcon onClick={() => setIsEdit(!isEdit)} className="w-4 h-4 mr-6 mt-2 cursor-pointer" />
            <DeleteIcon className="w-4 h-4 mt-2 cursor-pointer" onClick={onDelete} />
          </>
        )}
      </div>
    </div>
  );
};

export default HotWordGroup;
